<template>
  <div class="tag-color-picker">
    <div class="tag-color-swatch" @click="onSwatchClick"></div>
    <div v-if="edit">
      <span class="ml-2 is-size-6 has-text-grey">{{ color }}</span>
      <div v-if="showPicker" class="istagcolor">
        <div class="is-flex is-align-items-center has-background-white is-border-radius-sm is-justify-content-space-between">
          <MfColorPicker
            :colorValue="swatchColor"
            @update:color="onColorChange"
            :isCompColors="true"
            :isAdvancedColors="isAdvancedColors"
            @close-advanced-colors="isAdvancedColors = false"
            :moduleLabel="rowData?.name || 'Tag Color'"
            :edit="true"
          />
          <button
            class="button has-background-black-bis has-text-white px-0 mr-3 is-large"
            @click="isAdvancedColors = !isAdvancedColors"
            v-tooltip="'Advanced Colors'"
          >
            <i class="icon-settings"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import MfColorPicker from '@/components/MfColorPicker.vue';

export default {
  name: 'TagColorPicker',
  components: { MfColorPicker },
  props: {
    color: {
      type: String,
      default: '',
    },
    edit: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:color'],
  setup(props, { emit }) {
    const showPicker = ref(false);
    const isAdvancedColors = ref(false);

    const swatchColor = computed(() => props.color || props.rowData?.color || '#cccccc');
   
    const onSwatchClick = () => {
      if (props.edit) showPicker.value = !showPicker.value;
    };

    const onColorChange = (c) => {
      emit('update:color', c);
    };

    return { showPicker, isAdvancedColors, swatchColor, onSwatchClick, onColorChange };
  },
};
</script>

<style scoped>
.tag-color-picker {
  position: relative;
  display: flex;
  align-items: center;
}
.tag-color-swatch {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  border: 1px solid #777a86;
  background-color: v-bind(swatchColor);
  cursor: pointer;
  flex-shrink: 0;
}
.istagcolor {
  position: absolute;
  top: 40px;
  left: -80px;
  z-index: 99;

}

</style>